import React from 'react'
// import {useStyles} from './styles';
import CheckBoxInput from '../CheckBoxInput';
// import DatePicker from '../DatePicker';
// import SelectInput from '../DatePicker';
import TextInput from '../TextInput';
import {IFilterInput} from "./interfaces";

// TODO: this will need to be refactored to use component composition rather than a conditional statements
const FilterInput = (props: IFilterInput) => {
  const { name, type, label, value, onChange } = props;

  return (
    <>
      {
        ('checkbox' === type) && <CheckBoxInput
          name={name}
          label={label}
          value={value}
          required={props.required}
          disabled={props.disabled}
          icon={props.icon || undefined}
          checkedIcon={props.checkedIcon || undefined}
          onChange={onChange}
        />
      /* Uncomment the following lines if you want to include DatePicker and SelectInput components
        CMM: at present these are untested. However, they will be necessary if any report wishes to
        be able to order their filters by anything other than the SortFilter's default.
      }

      {
        ('date' == type) && <DatePicker
          name={name}
          label={label}
          value={value}
          suppressEventsForInvalidDates={suppressEventsForInvalidDates}
          onChange={onChange}
          disableFuture={disableFuture}
          minDate={minDate}
          maxDate={maxDate}
        />
      }
      {
        ('select' == type) && <SelectInput
          name={name}
          type={type}
          label={label}
          id={id}
          selectData={selectData}
          value={value}
          onChange={onChange}
          onNextClick={onNextClick}
          onPrevClick={onPrevClick}
          handleToggle={handleToggle}
          hasAction={hasAction}
          activeState={activeState}
          shrinkLabel={shrinkLabel}
        />*/
      }
      {
        ('text' === type || 'number' === type) && <TextInput
          name={name}
          label={label}
          value={value as string}
          type={type}
          numberField={props.numberField}
          inputProps={props.inputProps}
          placeholder={props.placeholder}
          onChange={onChange}
          onKeyDown={props.onKeyDown}
          fullWidth={props.fullWidth}
        />
      }
    </>
  )
}

export default FilterInput